interface DeviceItem {
  device: string
  platform: RegExp
}

const PLATFORMS = {
  android: 'android',
  ios: 'ios',
  linux: 'linux',
  mac: 'mac',
  windows: 'windows'
}

const USER_DEVICES_ARRAY: DeviceItem[] = [
  { device: 'android', platform: /Android/ },
  { device: 'ios', platform: /iPhone/ },
  { device: 'ios', platform: /iPad/ },
  { device: 'linux', platform: /Linux/ },
  { device: 'windows', platform: /Windows NT/ },
  { device: 'ios', platform: /Macintosh/ }
]

const getPlatform = (): string => {
  const platform = navigator.userAgent
  let userPlatform = PLATFORMS.mac
  USER_DEVICES_ARRAY.forEach(device => {
    if (device.platform.test(platform)) {
      userPlatform = device.device
    }
  })
  return userPlatform
}

export default getPlatform
